'use client';

import { GoogleOAuthProvider } from '@react-oauth/google';
import { TooltipProvider } from '@/components/ui/tooltip';

export function Providers({ googleClientId, children }: {
  googleClientId: string;
  children: React.ReactNode;
}) {
  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <TooltipProvider>
        {children}
      </TooltipProvider>
    </GoogleOAuthProvider>
  );
}
